module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABYBAMAAACpC9yoAAAAGFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWNxwqAAAACHRSTlMhABsNBRURCRSMDJ0AAADNSURBVEjH7da9CsJAEATgRU360UjaIBHrELDOaWFrFLH1Bx8g6PsjRJJTEzfTaONNOXzcwlUjbZlMd+cbXiIf09sa3dnsSSe+4Zx4hnPik05i0klCOp90kpPOI50cSdcnnRQtrndN0/llE739YdPhkdXpqVMcsLRvJppDWMOB6jCypeqwqA/rLoiqw7pDVn11hwu5u8ChLGfocsOyM5qzh3N0OqxFfBAuEykYN5YYjAs8UA4J6fAd12icc+4PnNsRbke4HeF2hNsRP90Rd+nggDeWj2/SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/about_left_icon01.png
// module id = nrJf
// module chunks = 1